import { render, staticRenderFns } from "./34bzhjyxbgb.vue?vue&type=template&id=54b96ad4&"
import script from "./34bzhjyxbgb.vue?vue&type=script&lang=js&"
export * from "./34bzhjyxbgb.vue?vue&type=script&lang=js&"
import style0 from "./34bzhjyxbgb.vue?vue&type=style&index=0&id=54b96ad4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports